import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { DeliAreaService } from '../../../service/deli-area/deli-area.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'app-root',
  templateUrl: 'wa9172.component.html',
  styleUrls: ['wa9172.component.css']
})
export class Wa9172Component implements OnInit {
  public componentTitle = 'WA9172:配送エリアマスタ修正';

  public ownerId: number;
  public ownerCd: string;
  public ownerTx: string;
  public deliareaId: number;
  public deliareaCd: string;
  public deliareaTx: FormControl;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(private router: Router, private deliAreaService: DeliAreaService, private commonService: CommonService, private dialogsService: DialogsService) {
    const deliarea: object = JSON.parse(sessionStorage.getItem('deliarea'));
    this.ownerId = deliarea['ownerId'];
    this.ownerCd = deliarea['ownerCd'];
    this.ownerTx = deliarea['ownerTx'];
    this.deliareaId = deliarea['deliareaId'];
    this.deliareaCd = deliarea['deliareaCd'];
    this.deliareaTx = deliarea['deliareaTx'];
    (this.deliareaTx = new FormControl(this.deliareaTx, [
      Validators.pattern(validation.emBlankOnly),
      Validators.pattern(validation.halfBlankOnly),
      Validators.maxLength(validation.deliareaTx.maxLength)
    ])),
      (this.containerHeight = window.innerHeight - config.containerheaderMargin);
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  ngOnInit() {}

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  onSubmit() {
    var deliareaTx = this.deliareaTx.value.trim();
    let errors = false;
    if (this.deliareaTx.errors !== null) {
      this.deliareaTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    this.working = true;
    const upduserId: number = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    this.deliAreaService
      .put(this.ownerId, this.deliareaId, this.deliareaCd, deliareaTx, 'wa9172')
      .then(outputJson => {
        this.working = false;
        this.router.navigate(['wa9170']);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9172/wa9172.component.ts